import { Base } from 'layouts'
import { IndustryForm } from 'components/Industry'

import * as S from './styled'

export function IndustryRegister() {
  return (
    <Base>
      <S.GridContainer container>
        <IndustryForm />
      </S.GridContainer>
    </Base>
  )
}
